import React from "react";
import { bem } from "../../helpers";
import Button from "../Button/Button";

const Tab = (props) => {
  const { className, activeTab, value, label } = props;

  return (
    <Button
      className={bem(
        "tabs",
        "item",
        [activeTab === value && "active"],
        className
      )}
      variant="text"
      onClick={() => {
        props.onClick && props.onClick(value);
      }}
    >
      {label}
    </Button>
  );
};

export default Tab;
